export default {
    base: 'https://api-dot-buildspace-core.ew.r.appspot.com'
}